import React from 'react';


const VettingSearchIcon = () => {

  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="7.125" cy="7.125" r="5.25" stroke="#282828" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.8359 10.8364L16.1244 16.1249" stroke="#282828" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default VettingSearchIcon;